import localeCacher from './locale'
export {
  LocaleDataType,
  LocaleConfigType,
  ComponentType,
  CompLangMsgParams,
  getLangMsg,
  getCompLangMsg,
} from './locale'
export default localeCacher
